'use client'

import { useLoginTracking } from '@maestro/commerce-blocks/hooks/use-login-tracker'

export default function LoginTrackerWrapper() {
  useLoginTracking()
  return null
}
